<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg2">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Services</h2>
                    <ul>
                        <li><a routerLink="/" itemprop="url" title="EWNS, Custom Ecommerce Platform to meet all your digital needs">Home</a></li>
                        <li>Services</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Area -->
<section class="services-area ptb-100 bg-F4F7FC">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Our Services</span>
        </div>

        <div class="row">
            

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-analytics"></i>
                    </div>
                    <h3><a routerLink="/services" title="Strategic Planning">Strategic Planning</a></h3>
                    <p>Our team will help you in giving you clear vision & path to acheive your business goals through different strategies.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-architecture"></i>
                    </div>
                    <h3><a routerLink="/services" title="Design & Development">Design & Development</a></h3>
                    <p>Our team will help you by designing & developing your digital storefront & to enable digital commerce, as per your branding needs.</p>
                    
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-seo"></i>
                    </div>
                    <h3><a routerLink="/services" title="Search Engine Optimization">SEO</a></h3>
                    <p>We employ multiple digital strategies & practices designed to increase quantity and quality of online traffic to your website through organic search results.</p>
                    
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-shopping-cart"></i>
                    </div>
                    <h3><a routerLink="/services" title="Ecommerce">Ecommerce</a></h3>
                    <p>Using our platform, one can easily create, manage online store and sell your products to anyone, anywhere in a secured way.</p>
                    
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-digital-marketing"></i>
                    </div>
                    <h3><a routerLink="/services" title="Digital Marketing">Digital Marketing</a></h3>
                    <p>We employ various marketing strategies that include PPC, Social Media, Content marketing etc to help your business acheive desired goals & ROI. </p>
                    
                </div>
            </div>

           

            

            

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-social-media"></i>
                    </div>
                    <h3><a routerLink="/services" title="Social Media">Social Media</a></h3>
                    <p>Social Media is critical for acquiring & engaging your potential customers. We provide native integrations with all major social media channels.</p>
                   
                </div>
            </div>

            
        </div>
    </div>
</section>
<!-- End Services Area -->